import React from 'react';
import * as ActionTypes from '../../constants/ActionTypes';
import { handleActions } from 'redux-actions';

const labelsDataStoreDefaults = {
    foldedValue: '',
    explicitValue: null,
    foldedValueCopy: '',
    explicitValueCopy: null,
    languageCode: '',
    objectToBeSaved: {},
    existingCleared: false,
    existingHidden: false,
    saveHandler: () => {},
    changed: false
};

const labelsDataStore = handleActions(
    {
        [ActionTypes.SET_ENGLISH_LABELS]: (state, action) => {
            return { ...state, englishLabels: action.value };
        },
        [ActionTypes.SET_LABELS]: (state, action) => {
            const englishLabels = state.englishLabels;
            return {
                ...state,
                foldedValue: Object.assign({}, englishLabels, action.foldedValue),
                explicitValue: action.explicitValue,
                foldedValueCopy: Object.assign({}, englishLabels, action.foldedValue),
                explicitValueCopy: action.explicitValue,
                languageCode: action.languageCode
            };
        },
        [ActionTypes.SET_HIGHER_ORDER_LABELS]: (state, action) => {
            const englishLabels = state.englishLabels;
            return { ...state, higherOrderFoldedValue: Object.assign({}, englishLabels, action.foldedValue) };
        },
        [ActionTypes.EDIT_LABELS]: (state, action) => {
            let existingHidden = state.existingHidden;
            const foldedValueCopy = state.foldedValueCopy;
            const explicitValueCopy = state.explicitValueCopy;
            const changedExplicitValue = explicitValueCopy ? explicitValueCopy : {};
            if (explicitValueCopy && explicitValueCopy[action.keyName] === '') {
                existingHidden = true;
            }
            const changedExplicits = {
                ...changedExplicitValue,
                [action.keyName]: action.value
            };
            const foldedValueObj = {
                ...foldedValueCopy,
                [action.keyName]: action.value
            };
            return {
                ...state,
                foldedValueCopy: foldedValueObj,
                changed: true,
                existingHidden,
                explicitValueCopy: changedExplicits
            };
        },
        [ActionTypes.SET_LABELS_SAVE_HANDLER]: (state, action) => ({
            ...state,
            saveHandler: action.handler
        }),
        [ActionTypes.LABELS_DISCARD_CHANGES]: state => ({
            ...state,
            existingHidden: false,
            existingCleared: false,
            changed: false,
            foldedValueCopy: state.foldedValue,
            explicitValueCopy: state.explicitValue,
            objectToBeSaved: {}
        }),
        [ActionTypes.CLEAR_LABELS]: (state, action) => {
            let { changed, existingCleared } = state;
            const foldedValue = state.foldedValue;
            const foldedValueCopy = state.foldedValueCopy;
            const explicitValueCopy = state.explicitValueCopy;
            const higherOrderFoldedValue = state.higherOrderFoldedValue;
            let changedExplicitValue = explicitValueCopy ? explicitValueCopy : {};
            const changedExplicitValueKeys = Object.keys(changedExplicitValue);
            let finalObj;
            if (changedExplicitValueKeys.length > 0) {
                const doesKeyExist = changedExplicitValueKeys.filter(e => {
                    return action.keyName === e;
                });
                existingCleared = true;
                changed = true;
                // finalObj = (doesKeyExist) ? return delete changedExplicitValue[action.keyName] : return {}
                if (doesKeyExist) {
                    delete changedExplicitValue[action.keyName];
                }
            }
            let foldedValueObj = { ...foldedValueCopy, [action.keyName]: higherOrderFoldedValue[action.keyName] };

            return {
                ...state,
                foldedValueCopy: foldedValueObj,
                existingCleared,
                changed,
                explicitValueCopy: changedExplicitValue
            };
        }
    },
    labelsDataStoreDefaults
);

export default labelsDataStore;



// WEBPACK FOOTER //
// ./src/reducers/labels/labelsReducer.js